import { render, staticRenderFns } from "./MainGeneralForm.vue?vue&type=template&id=75e1b80f"
import script from "./MainGeneralForm.vue?vue&type=script&lang=js"
export * from "./MainGeneralForm.vue?vue&type=script&lang=js"
import style0 from "./MainGeneralForm.vue?vue&type=style&index=0&id=75e1b80f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports